import { Box, Container, Typography } from "@mui/material";
import { Moment } from "moment";

import AbatimentosPontoDePartida from "./abatimentos";
import TabelaCustodia from "./tabelaCustodia";

type Props = {
  dataBase: Moment;
};

export default function CadastrarPontoDePartida({ dataBase }: Props) {
  return (
    <Container maxWidth="lg">
      <Box
        display="flex"
        flexDirection="column"
        style={{ width: "100%" }}
        paddingBottom={8}
      >
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box flexGrow={1}>
            <Typography
              variant="eyebrow"
              color="text.secondary"
              sx={{ display: "block", pt: 2 }}
            >
              Configuração inicial
            </Typography>
            <Typography
              variant="h2"
              color="text.primary"
              gutterBottom
              sx={{ pt: 1, pb: 1 }}
            >
              Ponto de partida
            </Typography>
            <Typography variant="body1" color="text.secondary" gutterBottom>
              Se tiver iniciado suas operações antes de{" "}
              <Typography
                component="span"
                variant="dataMono"
                sx={{ fontSize: "inherit" }}
              >
                {dataBase
                  .clone()
                  .tz("America/Sao_Paulo")
                  .add(1, "month")
                  .startOf("month")
                  .format("DD/MM/YYYY")}
              </Typography>
              , preencha a sua custódia inicial e prejuízos acumulados em{" "}
              <Typography
                component="span"
                variant="dataMono"
                sx={{ fontSize: "inherit" }}
              >
                {dataBase.clone().tz("America/Sao_Paulo").format("DD/MM/YYYY")}
              </Typography>
              .
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              gutterBottom
              sx={{ fontStyle: "italic" }}
            >
              Após preencher as informações, clique no "Salvar", e recalcule
              todos os seus meses já calculados.
            </Typography>
          </Box>
        </Box>
        <AbatimentosPontoDePartida dataBase={dataBase} />
        <TabelaCustodia data={dataBase} />
      </Box>
    </Container>
  );
}
